import { FunctionComponent } from "react";
import ErrorBoundary from "../components/ErrorBoundary";

const withErrorBoundary = function <T>(Component: FunctionComponent<T>) {
  return (props: T) => (
    <ErrorBoundary>
      <Component {...props} />
    </ErrorBoundary>
  );
};
export default withErrorBoundary;
